import { render } from "./PartForm.vue?vue&type=template&id=47d4f4b8"
import script from "./PartForm.vue?vue&type=script&lang=js"
export * from "./PartForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__